module.exports = __webpack_public_path__ + "static/media/blkwhiteview.39d31bd3.jpg";